import React, { useState, useEffect, useRef } from 'react'
import CookieFunctions from '../functions/CookieFunctions'
import globalFunctions from '../functions/GlobalFunctions'
import { CButton, CNav, CNavItem, CNavLink, CListGroup, CListGroupItem, CFormSelect, CRow, CFormLabel, CCol, CForm } from '@coreui/react'
import { Typeahead } from 'react-bootstrap-typeahead';


export default function Files({ pageFilter }) {
    const [datesFilter, setDatesFilter] = useState("all")
    const allfiles = useRef();
    const [filteredFiles, setFilteredFiles] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('')
    const [isLoading, setIsLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const search = useRef();

    useEffect(() => {
        fetchDrivers();

    }, []);


    const fetchDrivers = () => {
        setIsLoading(true);
        const myHeaders = new Headers();
        myHeaders.append('Authorization', 'Bearer ' + CookieFunctions.getJWTToken());

        if (CookieFunctions.getRole().includes('manager') || CookieFunctions.getRole().includes('dispatcher')) {
            fetch("/api/manager/getAllDrivers", {
                headers: myHeaders,
                method: 'GET'
            })
                .then((res) => {
                    if (res.ok) {
                        return res.json();
                    } else {
                        throw new Error();
                    }
                })
                .then((data) => {
                    setOptions(data);
                    setIsLoading(false);
                    setLoading(false);
                })
                .catch((e) => {
                    setError("Error occurred while fetching drivers.");
                    setIsLoading(false);
                });
        } else if (CookieFunctions.getRole().includes('admin')) {

            fetch("/api/admin/driver", {
                headers: myHeaders,
                method: 'GET'
            })
                .then((res) => {
                    if (res.ok) {
                        return res.json();
                    } else {
                        throw new Error();
                    }
                })
                .then((data) => {
                    setOptions(data);
                    setIsLoading(false);
                    setLoading(false);
                })
                .catch((e) => {
                    setError("Error occurred while fetching drivers.");
                    setIsLoading(false);
                });
        }

        
    };




    const handleSelection = (selected) => {
        if (selected.length === 1) {

            const myHeaders = new Headers();
            myHeaders.append('Authorization', 'Bearer ' + CookieFunctions.getJWTToken());

            const formData = new FormData();

            formData.append("mpp_id", selected[0].mpp_id)
            formData.append("trc_number", selected[0].trc_number)
            formData.append("mpp_type1", selected[0].driver_type)

            fetch("/api/drivers/files",
                {
                    headers: myHeaders,
                    method: 'POST',
                    body: formData,
                }
            ).then((res) => {
                if (res.ok) {
                    return res.json()
                } else {
                    throw new Error()
                }
            }).then((data) => {
                allfiles.current = data;
                filterPage(pageFilter);
                setLoading(false)
            }).catch((e) => {
                allfiles.current = [];
                setFilteredFiles(false);
                setLoading(false)
            })
        }
    };









    function filterPage(pageFilter) {
        var filterPage = allfiles.current.filter(file => {
            if (pageFilter === "payStub" && file.fileName.includes("PAYSTB")) {
                return file
            } else if (pageFilter === "settlements" && file.fileName.includes("STLMNT")) {
                return file
            } else if (pageFilter === "performance" && file.fileName.includes("Performance")) {
                return file
            } else if (pageFilter === "yearlyStatements" && file.fileName.includes("YR20")) {
                return file
            } else if (pageFilter === "maintenance" && file.fileName.includes("RMHOIN")) {
                return file
            } else if (pageFilter === "tolls" && (file.fileName.includes("IFTA") || file.fileName.includes("EZPASS") || file.fileName.includes("NYSTA") || file.fileName.includes("BWBCAD") || file.fileName.includes("BWBUSD") || file.fileName.includes("407ETR") || file.fileName.includes("BLUEBEACON") || file.fileName.includes("AMBASsADOR"))) {
                return file
            } else if (pageFilter === "fuel" && (file.fileName.includes("ESSOCAD") || file.fileName.includes("PETROUSD"))) {
                return file
            } else if (pageFilter === "other" && !(file.fileName.includes('YR20') || file.fileName.includes('Performance') || file.fileName.includes('STLMNT') || file.fileName.includes('PAYSTB') || file.fileName.includes('ESSOCAD') || file.fileName.includes('PETROUSD') ||
                file.fileName.includes('IFTA') || file.fileName.includes('EZPASS') || file.fileName.includes('NYSTA') || file.fileName.includes('BWBCAD') || file.fileName.includes('BWBUSD') || file.fileName.includes('407ETR') || file.fileName.includes('BLUEBEACON') ||
                file.fileName.includes('AMBASSADOR') || file.fileName.includes("RMHOIN"))) {
                return file
            } else if (pageFilter === "all") {
                return file;
            }
        });

        var getDate = new Date();
        var day = String(getDate.getDate() - 7); // subtract 7 to check for a week
        var month = String(getDate.getMonth() + 1); // add 1 because the months start at index 0 using Date()
        var year = String(getDate.getFullYear()).slice(-2);

        var filterDate = filterPage.filter(file => {
            var fileDate = file.fileName.substring(0, 6);
            var fileYear = fileDate.substring(0, 2);
            var fileMonth = fileDate.substring(2, 4);
            var fileDay = fileDate.substring(2, 6);

            if (datesFilter === "all") {
                return file
            } else if (datesFilter === "year" && fileYear === year) {
                return file
            } else if (datesFilter === "month" && fileYear === year && fileMonth === month) {
                return file
            } else if (datesFilter === "week" && fileYear === year && fileMonth === month && fileDay >= day) {
                return file
            }
        });

        if (filterDate.length > 0) {
            setFilteredFiles(filterDate);
        } else {
            setFilteredFiles(null)
        }


    }


    function getFiles() {
        // create the headers for the fetch 
        const myHeaders = new Headers();
        myHeaders.append('Authorization', 'Bearer ' + CookieFunctions.getJWTToken());

        fetch("/api/drivers/files",
            {
                headers: myHeaders,
                method: 'POST',
            }
        ).then((res) => {
            if (res.ok) {
                return res.json()
            } else {
                throw new Error()
            }
        }).then((data) => {
            allfiles.current = data;
            filterPage(pageFilter);
            setLoading(false)
        }).catch((e) => {
            setLoading(false)
        })
    }

    function download(fileData) {
        var b = b64ToBlob(fileData.fileBase64)
        const url = URL.createObjectURL(b);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileData.fileName;
        a.click();
        URL.revokeObjectURL(url);
    }

    function openInNewTab(fileData) {
        var b = b64ToBlob(fileData.fileBase64)
        const url = URL.createObjectURL(b);
        const a = document.createElement('a');
        a.href = url;
        a.target = '_blank';
        a.rel = 'noreferrer'
        a.click()

    }

    function b64ToBlob(base64String) {
        const byteCharacters = atob(base64String);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
            const slice = byteCharacters.slice(offset, offset + 512);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        return new Blob(byteArrays, { type: 'application/pdf' });
    }

    useEffect(() => {

        const userRoles = CookieFunctions.getRole();
        if (userRoles.includes('driver')) {
            setLoading(true)
            getFiles();
        }


    }, [])






    useEffect(() => {
        if (allfiles.current == null) return;

        filterPage(pageFilter);
    }, [pageFilter, datesFilter])



    return (
        <>
            {(CookieFunctions.getRole().includes('manager') || CookieFunctions.getRole().includes('dispatcher') || CookieFunctions.getRole().includes('admin'))&& (<CForm className='fs-4'>
                <CCol sm="5" xs="6">
                    <CFormLabel className='fs-4'>Search by Driver Name</CFormLabel>
                    <Typeahead
                        id="manager-search"
                        isLoading={isLoading}
                        labelKey={option => `${option.mpp_firstname} ${option.mpp_lastname} (${option.mpp_id})`}
                        onChange={handleSelection}
                        options={options}
                        ref={search}
                    />
                </CCol>
                {error && <p>{error}</p>}
            </CForm>)}
            <br />
            {(
                <CNav variant="tabs">
                    <CNavItem>
                        <CNavLink onClick={() => setDatesFilter("week")} active={datesFilter === "week"}>This week</CNavLink>
                    </CNavItem>
                    <CNavItem>
                        <CNavLink onClick={() => setDatesFilter("month")} active={datesFilter === "month"}>This month</CNavLink>
                    </CNavItem>
                    <CNavItem>
                        <CNavLink onClick={() => setDatesFilter("year")} active={datesFilter === "year"}>This year</CNavLink>
                    </CNavItem>
                    <CNavItem>
                        <CNavLink onClick={() => setDatesFilter("all")} active={datesFilter === "all"}>All time</CNavLink>
                    </CNavItem>
                </CNav>
            )}
            {loading ? (
                <div class="text-center">
                    <div class="spinner-border" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : (
                <CListGroup flush>
                        {filteredFiles ? filteredFiles.reverse().map((f, i) => {
                        return (
                            <CListGroupItem key={i} >
                                <CButton color='link' onClick={() => { download(f) }}>
                                    {f.fileName}
                                </CButton>
                                {/* <CButton color='link' onClick={() => { openInNewTab(f) }}>
                        {f.fileName}
                    </CButton> */}
                            </CListGroupItem>
                        )
                    }) : (
                        <CListGroupItem >
                            <p>No files to show</p>
                        </CListGroupItem>
                    )}
                </CListGroup>
            )}
        </>

    )
}